import { ArrowLeftIcon } from "@/components/icons"

import { cn } from "@/lib/utils"

export function BackLink({
  href,
  children,
  className,
  onClick,
}: {
  href?: string
  children: React.ReactNode
  className?: string
  onClick?: () => void
}) {
  const cls = cn(
    "mb-4 inline-flex max-w-max items-center gap-2 text-lg leading-6 text-muted-foreground transition-colors hover:text-brand cursor-pointer",
    className
  )
  const inner = (
    <>
      <ArrowLeftIcon className="size-[18px] shrink-0 stroke-[1.5]" />
      <span>{children}</span>
    </>
  )
  if (href) {
    return (
      <a href={href} className={cls}>
        {inner}
      </a>
    )
  }
  return (
    <button type="button" className={cls} onClick={onClick}>
      {inner}
    </button>
  )
}
